import React from 'react';
import './ServicesMedicationManagement.scss';

const ServicesMedicationManagement: React.FC = () => {
  return (
    <div className="page">
      <h1>Medication Management</h1>
      <p>Medication Management content goes here.</p>
    </div>
  );
};

export default ServicesMedicationManagement;

